import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dCoreSites$dTranslations$dKeys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAllergen from "../Restaumatic.Menu.V2.Types.Allergen/index.js";
const monoidSet = /* #__PURE__ */ Data$dSet.monoidSet(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen);
const foldMap = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(monoidSet))();
const toUnfoldableUnordered = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldrUnordered);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const foldMap1 = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(monoidSet))();
const translatedAllergen = v => {
  if (v.tag === "Gluten") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Gluten), {});
  }
  if (v.tag === "Crustaceans") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Crustaceans), {});
  }
  if (v.tag === "Eggs") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Eggs), {});
  }
  if (v.tag === "Fish") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Fish), {});
  }
  if (v.tag === "Peanuts") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Peanuts), {});
  }
  if (v.tag === "Soybeans") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Soybeans), {});
  }
  if (v.tag === "Milk") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Milk), {});
  }
  if (v.tag === "Nuts") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Nuts), {});
  }
  if (v.tag === "Celery") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Celery), {});
  }
  if (v.tag === "Mustard") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Mustard), {});
  }
  if (v.tag === "Sesame") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Sesame), {});
  }
  if (v.tag === "SulphurDioxide") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.SulphurDioxide), {});
  }
  if (v.tag === "Lupin") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Lupin), {});
  }
  if (v.tag === "Molluscs") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCoreSites$dTranslations$dKeys.t.allergens.Molluscs), {});
  }
  $runtime.fail();
};
const productKeyAllergens = catalogue => productKey => {
  const modifierValuesAllergens = modifierValues => foldMap(v => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v._1)(Data$dRecord.unsafeGet("modifiers")(catalogue));
    const itemMap = (() => {
      if ($0.tag === "Nothing") { return Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, []); }
      if ($0.tag === "Just") { return Restaumatic$dMenu$dV2$dMenuCatalogue.fold(Data$dFunctor.arrayMap(x => x.items)(Data$dRecord.unsafeGet("sections")($0._1))); }
      $runtime.fail();
    })();
    return foldMap(itemId => {
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(itemId)(itemMap._1);
      if ($1.tag === "Nothing") { return monoidSet.mempty; }
      if ($1.tag === "Just") { return Data$dMap.keys(Data$dRecord.unsafeGet("allergens")($1._1)); }
      $runtime.fail();
    })(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, Data$dMap.keys(v._2)));
  })(toUnfoldableUnordered(modifierValues));
  return Data$dMap$dInternal.unsafeUnionWith(
    Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen.compare,
    Data$dFunction.const,
    modifierValuesAllergens(Data$dRecord.unsafeGet("modifiers")(productKey)),
    foldMap1(part => Data$dMap$dInternal.unsafeUnionWith(
      Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen.compare,
      Data$dFunction.const,
      modifierValuesAllergens(Data$dRecord.unsafeGet("modifiers")(part)),
      (() => {
        const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(Data$dRecord.unsafeGet("productId")(part))(Data$dRecord.unsafeGet("products")(catalogue));
        if ($0.tag === "Nothing") { return monoidSet.mempty; }
        if ($0.tag === "Just") { return Data$dMap.keys(Data$dRecord.unsafeGet("allergens")($0._1)); }
        $runtime.fail();
      })()
    ))(Data$dRecord.unsafeGet("parts")(productKey))
  );
};
export {foldMap, foldMap1, monoidSet, productKeyAllergens, toUnfoldableUnordered, translatedAllergen};
